import IconsPage from '@/common/pages/Icons';
import {
  ADJUSTER_REPORT_BASE_PATH,
  DASHBOARD_BASE_PATH,
  EDUCATION_BASE_PATH,
  FILE_DETAIL_BASE_PATH,
  FILES_LIST_BASE_PATH,
  ICONS_PATH,
  STATISTIC_BASE_PATH,
} from '@/config/baseModulesLink.tsx';
import { AdjusterReportRoutes } from '@/modules/adjusterReportModules/adjusterReport/AdjusterReportRoutes';
import { PROFILE_PATH } from '@/modules/Dashboard/DashboardLinks';
import { DashboardRoutes } from '@/modules/Dashboard/DashboardRoutes.tsx';
import Profile from '@/modules/Dashboard/pages/Profile';
import { EducationRoutes } from '@/modules/Education/EducationRoutes';
import { FileDetailRoutes } from '@/modules/FileDetail/FileDetailRoutes';
import { FileListRoutes } from '@/modules/FileList/FileListRoutes.tsx';
import { StatisticsRoutes } from '@/modules/Statistics/StatisticsRoutes';
import { createBrowserRouter, Navigate, Outlet } from 'react-router-dom';

export const ProjectRoutes = createBrowserRouter([
  {
    element: <Outlet />,
    path: DASHBOARD_BASE_PATH,
    children: DashboardRoutes,
  },
  {
    element: <Outlet />,
    path: PROFILE_PATH,
    children: [
      {
        index: true,
        element: <Profile />,
      },
      {
        path: EDUCATION_BASE_PATH,
        children: EducationRoutes,
      },
      {
        path: STATISTIC_BASE_PATH,
        children: StatisticsRoutes,
      },
    ],
  },

  {
    element: <Outlet />,
    path: FILE_DETAIL_BASE_PATH,
    children: FileDetailRoutes,
  },
  {
    element: <Outlet />,
    path: FILES_LIST_BASE_PATH,
    children: FileListRoutes,
  },
  {
    element: <Outlet />,
    path: EDUCATION_BASE_PATH,
    children: EducationRoutes,
  },
  {
    element: <Outlet />,
    path: STATISTIC_BASE_PATH,
    children: StatisticsRoutes,
  },
  {
    element: <Outlet />,
    path: ADJUSTER_REPORT_BASE_PATH,
    children: AdjusterReportRoutes,
  },
  process.env.NODE_ENV === 'development'
    ? {
        path: ICONS_PATH,
        element: <IconsPage />,
      }
    : {},
  { path: '*', element: <Navigate to={DASHBOARD_BASE_PATH} /> },
]);
